import { format } from "date-fns";

export { createSelectorConfirm } from "./createSelectorConfirm";

export const defaultVerifSettingPengecekan = {
  jabatan_id: -1,
  it: [],
  kabag_transport: [],
  sd2: [],
};

export const defaultVerifSettingPemakaian = {
  jabatan_id: -1,
  1: [],
  2: [],
};

export const createPengecekanSaved = () => ({
  bagian_depan: false,
  bagian_samping: false,
  bagian_belakang: false,
  bagian_dalam: false,
});

export const getKendaraanIdFromUrl = () => {
  const url = window.location.href; // full URL
  const regex = /[?&]kendaraan_id=(\d+)/; // match ?kendaraan_id= or &kendaraan_id=
  const match = url.match(regex);
  return match ? match[1] : null;
};

// detil photos

export const updateImagePengecekanMobilDetilSingle = (detil) => {
  let newImage = detil.gambar;
  if (newImage) {
    if (!newImage.includes("?serial=")) {
      newImage = `${newImage}?serial=${Math.random()}`;
    }
  }
  return { ...detil, gambar: newImage };
};

// adds a ?serial= to every gambar so a replaced photo is not served from the browser cache
export const generateUpdatedImagePengecekanMobil = (detils) => {
  return detils.map((detil) => updateImagePengecekanMobilDetilSingle(detil));
};

// folder of the file manager the detil photos go to: audit/<date>/<nomor polisi>
export const getFotoFolderName = (headerData) => {
  const nomorPolisi = headerData.data_kendaraan
    ? headerData.data_kendaraan.nomor_polisi
    : null;
  const today = format(new Date(), "yyyy-MM-dd");
  return `audit/${nomorPolisi ? `${today}/${nomorPolisi}` : today}`.replaceAll(
    " ",
    "-"
  );
};

// data conversion methods (audit header: tanggal with time)

export const convertSaveHeader = (data) => {
  const value = { ...data };

  const { tanggal } = value;
  value.tanggal = new Date(
    tanggal.getFullYear(),
    tanggal.getMonth(),
    tanggal.getDate(),
    tanggal.getHours(),
    tanggal.getMinutes()
  );
  value.tanggal = format(value.tanggal, "yyyy-MM-dd HH:mm:00");

  return value;
};

export const convertLoadedHeader = (data) => {
  const newData = { ...data };

  const { tanggal } = newData;

  if (tanggal) {
    newData.tanggal = new Date(tanggal);
  }

  if (!newData.keterangan) {
    newData.keterangan = "";
  }

  return newData;
};

// Puts the rows the server sent back (`data`) in place of the rows of `detils` that have the same id, and resolves
// the rows that were only staged locally (a marking added with Beri Tanda has no id until the Save button sends it).
// sentDetils: the exact array that was sent (still carrying each row's _localId), in the same order as `data`
// (the backend's savemany keeps the order), so a staged row is resolved by position and matched back by _localId.
export const mergeSavedDetils = (detils, sentDetils, data) => {
  const byLocalId = {};
  sentDetils.forEach((sent, i) => {
    if (!sent.id && sent._localId && data[i]) {
      byLocalId[sent._localId] = data[i];
    }
  });

  const merged = detils.map((detil) => {
    if (detil._localId && byLocalId[detil._localId]) {
      return byLocalId[detil._localId];
    }
    const found = data.find((d) => d.id === detil.id);
    if (found) return found;
    return detil;
  });
  return generateUpdatedImagePengecekanMobil(merged);
};
